import React from 'react';
import Renderer from '@atlassian/jira-issue-view-media-renderer';

import { useEditorState } from '../../../../state';
import type { Props } from './types';

const ConnectedRenderer = ({ adf }: Props) => {
	const [{ mentionProvider, contextIdentifier, mediaContext }] = useEditorState();

	if (!mentionProvider || !contextIdentifier || !mediaContext) {
		return null;
	}

	return (
		<Renderer
			adf={adf}
			mentionProvider={mentionProvider}
			contextIdentifier={contextIdentifier}
			mediaContext={mediaContext}
		/>
	);
};

export default ConnectedRenderer;
